import React, { useState } from 'react';
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Box,
    IconButton
} from '@mui/material';
import {
    Warning as WarningIcon,
    Close as CloseIcon
} from '@mui/icons-material';

const ConfirmButton = ({
    title = "Confirmar Ação",
    message = "Tem certeza que deseja realizar esta ação?",
    confirmText = "Confirmar",
    cancelText = "Cancelar",
    confirmColor = "error",
    cancelColor = "inherit",
    variant = "contained",
    size = "medium",
    icon,
    onConfirm,
    onCancel,
    disabled = false,
    children,
    ...buttonProps
}) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        if (onCancel) {
            onCancel();
        }
    };

    const handleConfirm = () => {
        setOpen(false);
        if (onConfirm) {
            onConfirm();
        }
    };

    return (
        <>
            <Button
                {...buttonProps}
                variant={variant}
                size={size}
                color={confirmColor}
                disabled={disabled}
                onClick={handleOpen}
                startIcon={icon}
            >
                {children}
            </Button>

            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: 2,
                        boxShadow: '0px 8px 32px rgba(0, 0, 0, 0.12)'
                    }
                }}
            >
                <DialogTitle sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'space-between',
                    pb: 1
                }}>
                    <Box display="flex" alignItems="center" gap={1}>
                        <WarningIcon color="warning" />
                        <Typography variant="h6" component="div">
                            {title}
                        </Typography>
                    </Box>
                    <IconButton
                        onClick={handleClose}
                        size="small"
                        sx={{ color: 'text.secondary' }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{ pt: 1 }}>
                    <Typography variant="body1" color="text.secondary">
                        {message}
                    </Typography>
                </DialogContent>

                <DialogActions sx={{ p: 3, pt: 2, gap: 1 }}>
                    <Button
                        onClick={handleClose}
                        color={cancelColor}
                        variant="outlined"
                        sx={{ minWidth: 100 }}
                    >
                        {cancelText}
                    </Button>
                    <Button
                        onClick={handleConfirm}
                        color={confirmColor}
                        variant="contained"
                        sx={{ minWidth: 100 }}
                    >
                        {confirmText}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default ConfirmButton;
